import $ from 'jquery';

const $product_title = $('.product_title')
const $product_of_interest = $('.product-of-interest')

$('.post-type-archive-product')
    .on('click', '.quantity input', _ => false)
    .on('change input', '.quantity .qty', _ => {
        const $this = $(this);
        const $add_to_cart_button = $this.parents('.product').find('.add_to_cart_button');
        // For AJAX add-to-cart actions
        $add_to_cart_button.attr('data-quantity', $this.val());
        // For non-AJAX add-to-cart actions
        $add_to_cart_button.attr('href', `?add-to-cart=${$add_to_cart_button.attr('data-product_id')}&quantity=${this.val()}`);
    });


$(document.body).on('click', '#purchase-order-login', () => {
    const $loginForm = $('form.login, form.woocommerce-form--login');
    const $header = $('.site-header-wrap--stick');
    const $toggle = $('.woocommerce-form-login-toggle > .woocommerce-info');
    const position = $toggle.offset().top + $toggle.outerHeight(true) - $header.height() - 15;
    $('html, body').animate({scrollTop: position}, 1000, () => $loginForm.slideDown());
    return false;
});

$('[data-label="Request A Quote"]').on('click', () =>{
    sessionStorage.setItem('product_name', $product_title.text())
})

if($product_of_interest) {
    $product_of_interest.find('input').val(sessionStorage.getItem('product_name'))
}
